exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nux-flow-number{line-height:12px;margin-bottom:4px;margin-right:5px}.nux-link{outline:none}.nux-link p,.nux-link p .nux-flow-number{color:#528900!important}.nux-link p .nux-flow-number{border-color:#528900!important}.nux-link.active p,.nux-link.active p .nux-flow-number{color:#fff!important}.nux-link.active p .nux-flow-number{border-color:#fff!important}@media (max-width:768px){.nux-mobile-lesser{font-size:12px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c2df475","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/nux/nux-flow2.vue
// module id = 1134
// module chunks = 0